import styled from 'styled-components';
import { ActionFooter } from 'components/molecules/action-footer';
import { ProductiveHeading03, TextWrapper, BodyShort01 } from 'ozone/atoms';
export const Divider = styled.div`
  border-top: 1px solid var(--border-color);
`;
export const Separator = styled.div`
  margin: 0 var(--spacing-02);

  &::after {
    content: '·';
  }
`;
const Text = styled(TextWrapper)`
  padding: 0;
`;
export const Title = styled(ProductiveHeading03).attrs({
    as: Text
})``;
export const Content = styled(BodyShort01)``;
export const Footer = styled.div``;
const DrawerComponent = styled.div`
  --popover-spacing: var(--spacing-05);
  display: flex;
  width: 360px;
  flex-direction: column;
  align-items: stretch;
  height: 100%;

  ${Title} {
    padding: var(--popover-spacing) var(--popover-spacing)
      calc(2 * var(--popover-spacing));
    background: var(--coolest-gray-10);
    flex: 0 0 auto;
  }

  ${Content} {
    padding: var(--popover-spacing) var(--popover-spacing)
      calc(2 * var(--popover-spacing));
    flex: 1;
    overflow-y: auto;
  }

  ${Footer} {
    border-top: 1px solid var(--border-color);
    flex: 0 0 auto;
    padding: var(--popover-spacing);
  }

  ${ActionFooter} {
    margin: calc(var(--popover-spacing) / 2) var(--popover-spacing);
  }

  ${Divider} {
    margin-top: var(--popover-spacing);
  }
`;
const DrawerContent = DrawerComponent;
DrawerContent.Title = Title;
DrawerContent.Content = Content;
DrawerContent.Divider = Divider;
DrawerContent.Separator = Separator;
DrawerContent.Footer = Footer;
export { DrawerContent };
